import React, { Component } from "react";
import { Form, Input, message, Radio, Select } from 'antd';
import './forget.less';
import Button from "antd/es/button";
import { reqDoPassword, reqEmailCode, reqVerifyEmail, reqVerifyStudent, reqVerifyTeacher } from "../../api";
import Modal from "antd/es/modal";

const { Option } = Select;

/**
 * 登录的路由组件
 */
export class Forget extends Component {

    state = {
        userInfo: 'block',
        userEmail: 'none',
        identify: '班级',
        passInfo: 'none',
        userCode: 'none',
        token: "",
        visible: false,
        visible2: false
    };

    onIdentify = value => {
        if (value === 'student') {
            this.setState({
                identify: '班级'
            })
        } else {
            this.setState({
                identify: '院系'
            })
        }
    };

    onChange = e => {
        if (e.target.value === "byMobile") {
            this.setState({
                userInfo: 'block',
                userEmail: 'none',
                passInfo: 'none',
                userCode: 'none',
            })
        } else {
            this.setState({
                userInfo: 'none',
                userEmail: 'block',
                passInfo: 'none',
                userCode: 'none',
            })
        }
    };

    forgetInfoSubmit = (event) => {
        //组织表单的默认行为
        event.preventDefault();
        let verify = this.state.identify;
        //对所有表单字段进行校验
        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                let data = new FormData();
                let result = "";
                data.append("username", values.userName);
                data.append("name", values.name);
                data.append("mobile", values.mobile);
                data.append("email", values.email);
                if (verify === '班级') {
                    data.append("classroomName", values.identify);
                    for (let value of data.values()) {
                        // console.log(value);
                    }
                    result = await reqVerifyStudent(data);
                } else {
                    data.append("departmentName", values.identify);
                    result = await reqVerifyTeacher(data);
                }
                if (result.code === "000000") {
                    message.success("信息填写成功");
                    this.setState({
                        token: result.data,
                        userInfo: "none",
                        passInfo: 'block'
                    })
                }
            }
        });
    };

    changePassword = async () => {
        let password = document.getElementById("password11").value;
        let confirm = document.getElementById("confirm").value;
        if (password && confirm) {
            if (password === confirm) {
                let data = new FormData();
                data.append("pwd", password);
                data.append("token", this.state.token);
                const result = await reqDoPassword(data);
                if (result.code === '000000') {
                    message.success("重置成功");
                    this.props.history.replace("/login");
                }
            } else {
                message.error("两次密码不一致")
            }
        } else {
            message.error("请输入密码")
        }
    };

    replyCode = async () => {
        let email = document.getElementById("mod").value;
        let username = document.getElementById("username2").value;
        let data = new FormData();
        data.append("email", email);
        data.append("username", username);
        const result = await reqEmailCode(data);
        if (result.code === '000000') {
            message.success("验证码已发送");
        }
    };

    sendEmail = async () => {
        let email = document.getElementById("check").value;
        let username = document.getElementById("username").value;
        if (email && username) {
            let reg = /^([a-zA-Z]|[0-9])(\w|)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
            if (reg.test(email)) {
                let data = new FormData();
                data.append("email", email);
                data.append("username", username);
                const result = await reqEmailCode(data);
                if (result.code === '000000') {
                    message.success("验证码已发送");
                    this.setState({
                        userInfo: 'none',
                        userEmail: 'none',
                        passInfo: 'none',
                        userCode: 'block',
                        email: email,
                        username:username,
                    });
                }
            } else {
                document.getElementById("email_tip").innerHTML = "邮箱格式错误";
            }
        } else {
            document.getElementById("email_tip").innerHTML = "请输入预留邮箱";
            document.getElementById("username_tip").innerHTML = "请输入用户名";
        }
    };

    modEmail = () => {
        this.setState({
            visible: true
        })
    };

    modusername = () => {
        this.setState({
            visible2: true
        })
    };

    changeEmail = async () => {
        let email = document.getElementById("change").value;
        if (email) {
            let reg = /^([a-zA-Z]|[0-9])(\w|)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
            if (reg.test(email)) {
                this.setState({
                    email: email
                });
                this.handleCancel();
            } else {
                document.getElementById("email_tip").innerHTML = "邮箱格式错误";
            }
        } else {
            message.error("请输入预留邮箱")
        }
    };

    changeUsername = async () => {
        let username = document.getElementById("changeusername").value;
        if (username) {
            this.setState({
                username: username
            });
            this.handleCancel();

        } else {
            message.error("请输入用户名")
        }
    };

    handleCancel = () => {
        this.setState({
            visible: false,
            visible2: false
        })
    };

    verifyCode = async () => {
        let email = document.getElementById("mod").value;
        let code = document.getElementById("six").value;
        let username = document.getElementById("username2").value;
        let data = new FormData();
        data.append("email", email);
        data.append("verifyCode", code);
        data.append("username", username);
        const result = await reqVerifyEmail(data);
        if (result.code === '000000') {
            debugger
            this.setState({
                userInfo: 'none',
                userEmail: 'none',
                passInfo: 'block',
                userCode: 'none',
                token: result.data,
            })
            document.getElementById("password11").value = ''
        }
    };

    componentDidMount = async () => {
    };

    render() {
        const { getFieldDecorator } = this.props.form;
        const { passInfo, userInfo, userEmail, identify, userCode, email, username, } = this.state;

        return (
            <div className='forget'>
                <div className='title'>
                    <span className='name'>找回密码</span>
                    <Radio.Group defaultValue={'byMobile'} onChange={this.onChange}>
                        <Radio value={'byMobile'}>通过个人信息找回</Radio>
                        <Radio value={'byEmail'}>通过邮箱找回</Radio>
                    </Radio.Group>
                </div>
                <div className='phone' style={{ display: userInfo }}>
                    <Form onSubmit={this.forgetInfoSubmit} labelCol={{ span: 4 }}
                        wrapperCol={{ span: 6 }}>
                        <Form.Item label="用户名/学号">
                            {getFieldDecorator('userName', {
                                rules: [
                                    {
                                        required: true,
                                        message: '请输入用户名/学号',
                                    },
                                ],
                            })(<Input placeholder="请输入用户名/学号......" autoComplete={"off"} />)}
                        </Form.Item>
                        <Form.Item label="姓名">
                            {getFieldDecorator('name', {
                                rules: [{ required: true, message: '请输入姓名' }],
                            })(<Input placeholder="请输入姓名......" autoComplete={"off"} />)}
                        </Form.Item>
                        <Form.Item label="身份">
                            {getFieldDecorator('ident', {
                                rules: [
                                    {
                                        required: true,
                                        message: '请选择身份'
                                    }
                                ],
                            })(<Select placeholder="请选择身份......" onChange={this.onIdentify.bind(this)}>
                                <Option value={'student'}>学生</Option>
                                <Option value={'teacher'}>老师</Option>
                            </Select>)}
                        </Form.Item>
                        <Form.Item label={identify}>
                            {getFieldDecorator('identify', {
                                rules: [{ required: true, message: '请输入' + identify }],
                            })(<Input placeholder={"请输入" + identify} autoComplete={"off"} />)}
                        </Form.Item>
                        <Form.Item label="手机号">
                            {getFieldDecorator('mobile', {
                                rules: [
                                    {
                                        required: true,
                                        message: '请输入手机号'
                                    }, {
                                        pattern: /^1[3|4|5|7|8][0-9]\d{8}$/,
                                        message: '请输入正确的手机号'
                                    }
                                ],
                            })(<Input placeholder="请输入手机号......" autoComplete={"off"} />)}
                        </Form.Item>
                        <Form.Item label="邮箱">
                            {getFieldDecorator('email', {
                                rules: [
                                    {
                                        type: 'email',
                                        message: '邮箱格式错误',
                                    },
                                    {
                                        required: true,
                                        message: '请输入邮箱',
                                    },
                                ],
                            })(<Input placeholder="请输入邮箱......" autoComplete={"off"} />)}
                        </Form.Item>
                        <Form.Item>
                            <Button className='next' htmlType="submit">下一步</Button>
                        </Form.Item>
                    </Form>
                </div>
                <div className='password' style={{ display: passInfo }}>
                    <div className='item'>
                        <span className='item_span'>新密码：</span><Input.Password autoComplete={"off"} placeholder='请输入新密码' id='password11'  />
                    </div>
                    <div className='item'>
                        <span className='item_span'>确认新密码：</span><Input.Password autoComplete={"off"} placeholder='请输入新密码' id='confirm' />
                    </div>
                    <button className='pass_btn' onClick={this.changePassword.bind(this)}>确认</button>
                </div>
                <div className='password' style={{ display: userEmail }}>
                    <div className='item'>
                        <span>用户名：</span><Input placeholder='请输入用户名' id={"username"} /><span id='username_tip' style={{
                            color: '#f5222d',
                            fontSize: 12
                        }} />

                    </div>
                    <div className='item' style={{ marginLeft: '23px', display: 'flex' }}>
                        <span>邮箱：</span><Input placeholder='请输入预留邮箱' id={"check"} /><span id='email_tip' style={{
                            color: '#f5222d',
                            fontSize: 12
                        }} />

                    </div>

                    <div className='message'>验证码将会发送至你的预留邮箱</div>
                    <button className='email_btn' onClick={this.sendEmail}>下一步</button>
                </div>
                <div className='password for' style={{ display: userCode }}>
                    <div className='item'>
                        <span>用户名：</span>
                        <div className='email_for'><Input placeholder='请输入用户名' value={username} id={"username2"} />
                            <a className={'email_mod'} onClick={this.modusername}>修改</a>
                        </div>
                    </div>
                    <div className='item'>
                        <span>邮箱：</span>
                        <div className='email_for'><Input placeholder='请输入预留邮箱' value={email} id={"mod"} />
                            <a className={'email_mod'} onClick={this.modEmail}>修改</a>
                        </div>
                    </div>
                    <div className='item'>
                        <span>验证码：</span>
                        <div className='email_for'><Input autoComplete={"off"} placeholder='请输入6位验证码' id='six' /><a className={'email_mod'}
                            onClick={this.replyCode}>重新获取验证码</a>
                        </div>
                    </div>
                    <button className='pass_btn' onClick={this.verifyCode}>下一步</button>
                </div>

                <Modal
                    title="修改邮箱"
                    visible={this.state.visible}
                    onOk={this.changeEmail}
                    onCancel={this.handleCancel}
                    okText="确认"
                    cancelText="取消">
                    <Input id='change' defaultValue={email} />
                </Modal>

                <Modal
                    title="修改用户名"
                    visible={this.state.visible2}
                    onOk={this.changeUsername}
                    onCancel={this.handleCancel}
                    okText="确认"
                    cancelText="取消">
                    {/* <Input id='changeusername'/> */}
                    <Input id='changeusername' defaultValue={username} />
                </Modal>
            </div>
        )
    }
}

/**
 * 包装Form组件形成新的组件Forms(Login)
 * 新组件会向Form组件提供强大的对象属性：from
 */
const WrapForget = Form.create()(Forget);
export default WrapForget;